<template>
  <div class="language-modal" v-if="show">
    <div class="language-modal-content">
      <div class="modal-header">
        <div class="cyber-lines left"></div>
        <h2>SELECT LANGUAGE</h2>
        <div class="cyber-lines right"></div>
      </div>
      <div class="language-options">
        <div class="language-option" @click="selectLanguage('en')" :class="{ 'hover-effect': hoverLang === 'en' }" 
             @mouseenter="hoverLang = 'en'" @mouseleave="hoverLang = null">
          <div class="flag-container">
            <div class="flag usa-flag"></div>
            <div class="flag-glow"></div>
          </div>
          <span>English</span>
        </div>
        <div class="language-option" @click="selectLanguage('es')" :class="{ 'hover-effect': hoverLang === 'es' }"
             @mouseenter="hoverLang = 'es'" @mouseleave="hoverLang = null">
          <div class="flag-container">
            <div class="flag spain-flag"></div>
            <div class="flag-glow"></div>
          </div>
          <span>Español</span>
        </div>
        <div class="language-option" @click="selectLanguage('pt')" :class="{ 'hover-effect': hoverLang === 'pt' }"
             @mouseenter="hoverLang = 'pt'" @mouseleave="hoverLang = null">
          <div class="flag-container">
            <div class="flag brazil-flag"></div>
            <div class="flag-glow"></div>
          </div>
          <span>Português</span>
        </div>
        <div class="language-option" @click="selectLanguage('zh')" :class="{ 'hover-effect': hoverLang === 'zh' }"
             @mouseenter="hoverLang = 'zh'" @mouseleave="hoverLang = null">
          <div class="flag-container">
            <div class="flag china-flag"></div>
            <div class="flag-glow"></div>
          </div>
          <span>中文</span>
        </div>
      </div>
      <div class="modal-circuit-decoration"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChangeLanguageModal',
  data() {
    return {
      show: false,
      hoverLang: null
    }
  },
  methods: {
    showModal() {
      this.show = true;
    },
    hideModal() {
      this.show = false;
    },
    selectLanguage(lang) {
      // Save the selected language to localStorage
      localStorage.setItem('language', lang);
      this.hideModal();
      
      // Emit an event to notify parent components
      this.$emit('language-selected', lang);
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@400;700&display=swap');

.language-modal {
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  perspective: 1000px;
}

.language-modal-content {
  background-color: #0a0a0a;
  padding: 2rem 1.5rem;
  border-radius: 5px;
  width: 90%;
  max-width: 600px;
  text-align: center;
  border: 1px solid #ff3333;
  box-shadow: 0 0 20px rgba(255, 51, 51, 0.5), 
              inset 0 0 10px rgba(255, 51, 51, 0.3);
  position: relative;
  transform-style: preserve-3d;
  animation: modalAppear 0.5s ease-out forwards;
}

@keyframes modalAppear {
  from {
    opacity: 0;
    transform: translateY(30px) rotateX(10deg);
  }
  to {
    opacity: 1;
    transform: translateY(0) rotateX(0);
  }
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
  position: relative;
}

.modal-header h2 {
  font-family: 'Orbitron', sans-serif;
  font-weight: 700;
  font-size: 1.8rem;
  color: #ffffff;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin: 0 15px;
  text-shadow: 0 0 10px rgba(255, 51, 51, 0.7);
}

.cyber-lines {
  height: 2px;
  background: #ff3333;
  flex-grow: 1;
  position: relative;
}

.cyber-lines::before {
  content: '';
  position: absolute;
  height: 8px;
  width: 8px;
  background: #ff3333;
  top: 50%;
  transform: translateY(-50%);
}

.cyber-lines.left::before {
  right: 0;
}

.cyber-lines.right::before {
  left: 0;
}

.language-options {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 30px;
  margin-bottom: 20px;
}

.language-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding: 15px;
  border-radius: 5px;
  transition: all 0.3s ease;
  background-color: rgba(20, 20, 20, 0.8);
  border: 1px solid rgba(255, 51, 51, 0.3);
  width: 110px;
  height: 110px;
  justify-content: center;
  position: relative;
}

.language-option::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 1px solid transparent;
  opacity: 0;
  transition: all 0.3s ease;
}

.language-option.hover-effect::after {
  border-color: #ff3333;
  opacity: 1;
  box-shadow: 0 0 15px rgba(255, 51, 51, 0.7);
}

.language-option span {
  color: #ffffff;
  font-family: 'Orbitron', sans-serif;
  font-weight: 400;
  font-size: 0.9rem;
  margin-top: 10px;
  transition: all 0.3s ease;
}

.language-option.hover-effect span {
  color: #ff3333;
  text-shadow: 0 0 5px rgba(255, 51, 51, 0.7);
}

.flag-container {
  position: relative;
  width: 70px;
  height: 45px;
  transform-style: preserve-3d;
  perspective: 300px;
}

.flag {
  width: 70px;
  height: 45px;
  background-size: cover;
  background-position: center;
  border: none;
  position: relative;
  z-index: 2;
  transition: transform 0.3s ease;
}

.language-option.hover-effect .flag {
  transform: translateZ(10px);
}

.flag-glow {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  box-shadow: 0 0 0 0 rgba(255, 51, 51, 0);
  transition: all 0.3s ease;
  z-index: 1;
}

.language-option.hover-effect .flag-glow {
  box-shadow: 0 0 15px 2px rgba(255, 51, 51, 0.7);
}

.modal-circuit-decoration {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 5px;
  background: linear-gradient(90deg, 
    transparent 0%, 
    #ff3333 20%, 
    transparent 30%,
    #ff3333 40%,
    transparent 50%,
    #ff3333 60%,
    transparent 70%,
    #ff3333 80%,
    transparent 100%);
  opacity: 0.7;
}

/* Add a tech-like circuit pattern to the background */
.language-modal-content::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: 
    radial-gradient(circle at 25% 25%, rgba(255, 51, 51, 0.1) 1px, transparent 1px),
    radial-gradient(circle at 75% 75%, rgba(255, 51, 51, 0.1) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 51, 51, 0.03) 1px, transparent 1px),
    linear-gradient(rgba(255, 51, 51, 0.03) 1px, transparent 1px);
  background-size: 20px 20px, 20px 20px, 20px 20px, 20px 20px;
  background-position: 0 0, 0 0, -10px -10px, -10px -10px;
  z-index: -1;
}

.usa-flag {
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 600"><rect width="900" height="600" fill="%23bf0a30"/><rect width="900" height="46.15" fill="%23fff" y="46.15"/><rect width="900" height="46.15" fill="%23fff" y="138.45"/><rect width="900" height="46.15" fill="%23fff" y="230.75"/><rect width="900" height="46.15" fill="%23fff" y="323.05"/><rect width="900" height="46.15" fill="%23fff" y="415.35"/><rect width="900" height="46.15" fill="%23fff" y="507.65"/><rect width="346.15" height="323.05" fill="%23002868"/><circle r="15" cx="30" cy="30" fill="%23fff"/><circle r="15" cx="96" cy="30" fill="%23fff"/><circle r="15" cx="162" cy="30" fill="%23fff"/><circle r="15" cx="228" cy="30" fill="%23fff"/><circle r="15" cx="294" cy="30" fill="%23fff"/><circle r="15" cx="63" cy="63" fill="%23fff"/><circle r="15" cx="129" cy="63" fill="%23fff"/><circle r="15" cx="195" cy="63" fill="%23fff"/><circle r="15" cx="261" cy="63" fill="%23fff"/><circle r="15" cx="327" cy="63" fill="%23fff"/><circle r="15" cx="30" cy="96" fill="%23fff"/><circle r="15" cx="96" cy="96" fill="%23fff"/><circle r="15" cx="162" cy="96" fill="%23fff"/><circle r="15" cx="228" cy="96" fill="%23fff"/><circle r="15" cx="294" cy="96" fill="%23fff"/><circle r="15" cx="63" cy="129" fill="%23fff"/><circle r="15" cx="129" cy="129" fill="%23fff"/><circle r="15" cx="195" cy="129" fill="%23fff"/><circle r="15" cx="261" cy="129" fill="%23fff"/><circle r="15" cx="327" cy="129" fill="%23fff"/><circle r="15" cx="30" cy="162" fill="%23fff"/><circle r="15" cx="96" cy="162" fill="%23fff"/><circle r="15" cx="162" cy="162" fill="%23fff"/><circle r="15" cx="228" cy="162" fill="%23fff"/><circle r="15" cx="294" cy="162" fill="%23fff"/><circle r="15" cx="63" cy="195" fill="%23fff"/><circle r="15" cx="129" cy="195" fill="%23fff"/><circle r="15" cx="195" cy="195" fill="%23fff"/><circle r="15" cx="261" cy="195" fill="%23fff"/><circle r="15" cx="327" cy="195" fill="%23fff"/><circle r="15" cx="30" cy="228" fill="%23fff"/><circle r="15" cx="96" cy="228" fill="%23fff"/><circle r="15" cx="162" cy="228" fill="%23fff"/><circle r="15" cx="228" cy="228" fill="%23fff"/><circle r="15" cx="294" cy="228" fill="%23fff"/><circle r="15" cx="63" cy="261" fill="%23fff"/><circle r="15" cx="129" cy="261" fill="%23fff"/><circle r="15" cx="195" cy="261" fill="%23fff"/><circle r="15" cx="261" cy="261" fill="%23fff"/><circle r="15" cx="327" cy="261" fill="%23fff"/><circle r="15" cx="30" cy="294" fill="%23fff"/><circle r="15" cx="96" cy="294" fill="%23fff"/><circle r="15" cx="162" cy="294" fill="%23fff"/><circle r="15" cx="228" cy="294" fill="%23fff"/><circle r="15" cx="294" cy="294" fill="%23fff"/></svg>');
}

.spain-flag {
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 750 500"><rect width="750" height="500" fill="%23c60b1e"/><rect width="750" height="250" fill="%23ffc400" y="125"/></svg>');
}

.brazil-flag {
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 720 504"><rect width="720" height="504" fill="%2300992B"/><path d="M360,72 L684,252 L360,432 L36,252 Z" fill="%23FEDD00"/><circle cx="360" cy="252" r="96" fill="%23053087"/></svg>');
}

.china-flag {
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 600"><rect width="900" height="600" fill="%23de2910"/><g fill="%23ffde00"><path d="M5,20 L15,45 L40,45 L20,60 L30,85 L5,70 L-15,85 L-5,60 L-25,45 L0,45 Z" transform="translate(100,100) scale(3)"/><path d="M5,20 L15,45 L40,45 L20,60 L30,85 L5,70 L-15,85 L-5,60 L-25,45 L0,45 Z" transform="translate(200,50) scale(1)"/><path d="M5,20 L15,45 L40,45 L20,60 L30,85 L5,70 L-15,85 L-5,60 L-25,45 L0,45 Z" transform="translate(200,150) scale(1)"/><path d="M5,20 L15,45 L40,45 L20,60 L30,85 L5,70 L-15,85 L-5,60 L-25,45 L0,45 Z" transform="translate(150,100) scale(1)"/><path d="M5,20 L15,45 L40,45 L20,60 L30,85 L5,70 L-15,85 L-5,60 L-25,45 L0,45 Z" transform="translate(200,200) scale(1)"/></g></svg>');
}

@media (max-width: 768px) {
  .language-options {
    gap: 15px;
  }
  
  .language-option {
    width: 90px;
    height: 100px;
  }
  
  .flag {
    width: 60px;
    height: 38px;
  }
  
  .modal-header h2 {
    font-size: 1.4rem;
  }
}
</style>
